@if (isLoadingResults) {
  <div class="example-loading-shade">
    <mat-spinner [style.zoom]="1"></mat-spinner>
  </div>
}
<div
  cdkDrag
  class="popup_main_div add_report_main add_top_clients"
  cdkDragRootElement=".cdk-overlay-pane"
>
  <h2 cdkDragHandle mat-dialog-title class="mat-dialog-header">
    <span>{{ title }}</span>
    <button
      class="close-btn"
      mat-icon-button
      (click)="ondialogcloseClick($event)"
      aria-label="Close dialog"
    >
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <div mat-dialog-content class="mat-typography" style="overflow: unset">
    <div
      class="one"
      fxLayout="column"
      fxLayoutAlign="start"
      fxLayout.gt-md="row"
      style="width: 100%"
    >
      @if (!isPDFGenerated && !isLoadingResultsU && showwarningdiv == 'false') {
        <form
          fxLayout="column"
          fxFlex="1 0 auto"
          name="form"
          [formGroup]="ReportForm"
          id="ReportForm"
        >
          @if (responseData.DATERANGE) {
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
              @if (this.MatterFeildShow) {
                <mat-form-field
                  class="example custom-select pr-1"
                  fxFlex="100"
                  appearance="outline"
                  [ngClass]="{
                    'has-error': mattername.length == 0,
                  }"
                >
                  <mat-label>Matters</mat-label>
                  <mat-chip-grid #chipList aria-label="Matter selection">
                    @for (matterdata of mattername; track matterdata) {
                      <mat-chip-row (removed)="remove(matterdata)" class="mat-chips-selected">
                        @if (mattername.lenght != 0) {
                          <span>
                            <span>
                              {{ matterdata | slice: 0 : 40 }}
                              @if (matterdata.length > 50) {
                                ...
                              }
                            </span>
                          </span>
                        }
                        @if (router.url !== '/matter-details/matter-detail-dashboard') {
                          <button matChipRemove class="canclebutton">
                            <mat-icon style="font-size: 18px !important">cancel</mat-icon>
                          </button>
                        }
                      </mat-chip-row>
                    }
                    <input
                      matInput
                      (keydown.Tab)="datashow($event)"
                      formControlName="SHORTNAME"
                      #MatterInput1
                      [matAutocomplete]="autoMatter"
                      [matChipInputFor]="chipList"
                      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                      (matChipInputTokenEnd)="add($event)"
                      (keyup)="onKeyUp($event)"
                      required
                      [readonly]="router.url === '/matter-details/matter-detail-dashboard'"
                      [ngClass]="
                        (!isMulti || isMulti == 'no' || isMulti == 'No') && mattername.length > 0
                          ? 'hideInput'
                          : 'showInput'
                      "
                    />
                  </mat-chip-grid>
                  <mat-autocomplete
                    #autoMatter="matAutocomplete"
                    (optionSelected)="selectedValue($event)"
                  >
                    @for (data of matterlist; track data) {
                      <mat-option
                        class="mat-option_1"
                        (click)="selectedmatterguid(data)"
                        value="{{ data.MATTERGUID }}"
                      >
                        <!-- {{data.SHORTNAME}}--{{data.MATTER}} -->
                        {{ data.SELECTEDDESCRIPTION }}
                      </mat-option>
                    }
                  </mat-autocomplete>
                  <mat-icon class="matternews" matSuffix (click)="SelectMatter()">
                    <!-- <img class="icon_set" src="assets/icons/web_app/icon_matter_d.ico"> -->
                    <img
                      src="assets/icons/web_app/Frame 36.svg"
                      matTooltip="Select Matter"
                      matTooltipPosition="above"
                    />
                  </mat-icon>
                </mat-form-field>
              }
            </div>
          }
          @if (responseData.DATERANGE) {
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
              <mat-form-field class="example custom-select pr-1" fxFlex="100" appearance="outline">
                <mat-label>Date Range List</mat-label>
                <mat-select
                  formControlName="DATERANGE"
                  #values
                  name="DATERANGE"
                  (selectionChange)="hideshowdatepicker($event.value)"
                  panelClass="height_custom_scroll"
                >
                  @for (Dropdowndatename of responseData.DATERANGE; track Dropdowndatename) {
                    <mat-option [value]="Dropdowndatename.TEXT">
                      {{ Dropdowndatename.TEXT }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
          @if (responseData.DATERANGE) {
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
              <div class="one" fxLayout="column">
                @if (title != 'Aged Debtors') {
                  <div>
                    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
                      <mat-label>From Date</mat-label>
                      <input
                        matInput
                        placeholder="Choose a From date"
                        formControlName="ReportDateStart"
                        name="ReportDateStart"
                        [matDatepicker]="fromDate"
                        [max]="ReportForm.get('DateEnd')?.value"
                        [errorStateMatcher]="dateRangeMatcher"
                      />
                      <mat-datepicker-toggle matSuffix [for]="fromDate"></mat-datepicker-toggle>
                      <mat-datepicker #fromDate></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
                      <mat-label>To Date</mat-label>
                      <input
                        matInput
                        placeholder="Choose a To date"
                        formControlName="DateEnd"
                        name="DateEnd"
                        [matDatepicker]="toDate"
                        [min]="ReportForm.get('ReportDateStart')?.value"
                        [errorStateMatcher]="dateRangeMatcher"
                      />
                      <mat-datepicker-toggle matSuffix [for]="toDate"></mat-datepicker-toggle>
                      <mat-datepicker #toDate></mat-datepicker>
                      @if (ReportForm.hasError('dateRange')) {
                        <mat-error>From Date cannot be later than To Date</mat-error>
                      }
                    </mat-form-field>
                  </div>
                }
                @if (title == 'Aged Debtors') {
                  <div>
                    <mat-form-field appearance="outline" class="example pr-1" fxFlex="100">
                      <mat-label>Date To</mat-label>
                      <input
                        matInput
                        name="DateEnd"
                        formControlName="DateEnd"
                        [matDatepicker]="dateto"
                        placeholder="Date To"
                      />
                      <mat-datepicker-toggle matSuffix [for]="dateto"></mat-datepicker-toggle>
                      <mat-datepicker #dateto></mat-datepicker>
                    </mat-form-field>
                  </div>
                }
              </div>
            </div>
          }
          @if (SHOWTRUSTACCOUNT == 1) {
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
              @if (MULTITRUST == 0) {
                <mat-form-field appearance="outline" fxFlex="100" class="pr-1">
                  <mat-label>Trust Account</mat-label>
                  <input
                    formControlName="TrustAccount"
                    placeholder="Trust Account"
                    matInput
                    readonly
                  />
                </mat-form-field>
              }
              @if (MULTITRUST == 1) {
                <mat-form-field appearance="outline" fxFlex="100" class="pr-1">
                  <mat-label>Trust Account</mat-label>
                  <mat-select
                    formControlName="TRUSTACCOUNTGUID"
                    (selectionChange)="changeGuid($event)"
                  >
                    @for (account of TRUSTACCOUNTLIST; track account) {
                      <mat-option [value]="account.BANKACCOUNTGUID">
                        {{ account.BANKACCOUNTNAME }} - Balance:
                        {{ account.BANKACCOUNTBALANCE | currency }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
            </div>
          }
          @if (responseData.FEEEARNERS && responseData.SHOWFEEEARNERS) {
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
              <mat-form-field class="example pr-1" fxFlex="100" appearance="outline">
                <mat-label>{{ responseData.FEEEARNERPROMPT }}</mat-label>
                <mat-select
                  formControlName="FEEEARNERNAME"
                  name="FEEEARNERNAME"
                  [(value)]="responseData.FEEEARNERS[0].FEEEARNERGUID"
                  [(ngModel)]="responseData.FEEEARNERS[0].FEEEARNERGUID"
                >
                  @for (SelectOwnername of responseData.FEEEARNERS; track SelectOwnername) {
                    <mat-option [value]="SelectOwnername.FEEEARNERGUID">
                      {{ SelectOwnername.FEEEARNERNAME }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
          @if (responseData.SHOWMULTIFEEEARNERS) {
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
              <mat-form-field class="example pr-1" fxFlex="100" appearance="outline">
                <mat-label>Multi {{ responseData.FEEEARNERPROMPT }}</mat-label>
                <mat-select
                  multiple
                  formControlName="MULTIFEEEARNERLIST"
                  [(ngModel)]="selected"
                  name="MULTIFEEEARNERLIST"
                  (selectionChange)="multiFeeEarnerChange($event.value)"
                >
                  @for (SelectOwnername of responseData.FEEEARNERS; track SelectOwnername) {
                    <mat-option [value]="SelectOwnername.FEEEARNERGUID">
                      {{ SelectOwnername.FEEEARNERNAME }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
          @if (responseData.SHOWFEEEARNERS2) {
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
              <mat-form-field class="example pr-1" fxFlex="100" appearance="outline">
                <mat-label>{{ responseData.FEEEARNERPROMPT2 }}</mat-label>
                <mat-select
                  (selectionChange)="FE2Click($event.value, selectedvalue)"
                  #selectedvalue
                  formControlName="FEEEARNERNAME2"
                  name="FEEEARNERNAME2"
                  [(value)]="responseData.FEEEARNERS2[0].FEEEARNERGUID"
                  [(ngModel)]="responseData.FEEEARNERS2[0].FEEEARNERGUID"
                >
                  @for (SelectOwnername of responseData.FEEEARNERS2; track SelectOwnername) {
                    <mat-option [value]="SelectOwnername.FEEEARNERGUID">
                      {{ SelectOwnername.FEEEARNERNAME }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
          @if (responseData.LIST1) {
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
              <mat-form-field class="example pr-1" fxFlex="100" appearance="outline">
                <mat-label>{{ responseData.LISTPROMPT1 }}</mat-label>
                <mat-select
                  formControlName="LIST1TEXT"
                  name="LIST1TEXT"
                  [(value)]="responseData.LIST1[0].VALUE"
                  [(ngModel)]="responseData.LIST1[0].VALUE"
                >
                  @for (Selectsortordername of responseData.LIST1; track Selectsortordername) {
                    <mat-option [value]="Selectsortordername.VALUE">
                      {{ Selectsortordername.TEXT }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
          @if (responseData.LIST2) {
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
              <mat-form-field class="example pr-1" fxFlex="100" appearance="outline">
                <mat-label>{{ responseData.LISTPROMPT2 }}</mat-label>
                <mat-select
                  formControlName="LIST2TEXT"
                  name="LIST2TEXT"
                  [(value)]="responseData.LIST2[indexLIST2].VALUE"
                  [(ngModel)]="responseData.LIST2[indexLIST2].VALUE"
                >
                  @for (List2name of responseData.LIST2; track List2name) {
                    <mat-option [value]="List2name.VALUE">
                      {{ List2name.TEXT }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
          @if (
            responseData.OPTIONTEXT1 ||
            responseData.OPTIONTEXT2 ||
            responseData.OPTIONTEXT3 ||
            responseData.OPTIONTEXT4 ||
            responseData.OPTIONTEXT5 ||
            responseData.OPTIONTEXT6 ||
            responseData.OPTIONTEXT7 ||
            responseData.OPTIONTEXT8 ||
            responseData.OPTIONTEXT9 ||
            responseData.OPTIONTEXT10
          ) {
            <div>
              <div
                fxLayout="row wrap"
                fxLayoutAlign="start center"
                fxFlex="1 0 auto"
                class="label max-w-full"
              >
                @if (responseData.OPTIONTEXT1) {
                  <div fxFlex="50">
                    <mat-checkbox class="example-margin" formControlName="OPTIONTEXT1">
                      {{ responseData.OPTIONTEXT1 }}
                    </mat-checkbox>
                  </div>
                }
                @if (responseData.OPTIONTEXT2) {
                  <div fxFlex="50">
                    <mat-checkbox class="example-margin" formControlName="OPTIONTEXT2">
                      {{ responseData.OPTIONTEXT2 }}
                    </mat-checkbox>
                  </div>
                }
                @if (responseData.OPTIONTEXT3) {
                  <div fxFlex="50">
                    <mat-checkbox class="example-margin" formControlName="OPTIONTEXT3">
                      {{ responseData.OPTIONTEXT3 }}
                    </mat-checkbox>
                  </div>
                }
                @if (responseData.OPTIONTEXT4) {
                  <div fxFlex="50">
                    <mat-checkbox class="example-margin" formControlName="OPTIONTEXT4">
                      {{ responseData.OPTIONTEXT4 }}
                    </mat-checkbox>
                  </div>
                }
                @if (responseData.OPTIONTEXT5) {
                  <div fxFlex="50">
                    <mat-checkbox class="example-margin" formControlName="OPTIONTEXT5">
                      {{ responseData.OPTIONTEXT5 }}
                    </mat-checkbox>
                  </div>
                }
                @if (responseData.OPTIONTEXT6) {
                  <div fxFlex="50">
                    <mat-checkbox class="example-margin" formControlName="OPTIONTEXT6">
                      {{ responseData.OPTIONTEXT6 }}
                    </mat-checkbox>
                  </div>
                }
                @if (responseData.OPTIONTEXT7) {
                  <div fxFlex="50">
                    <mat-checkbox class="example-margin" formControlName="OPTIONTEXT7">
                      {{ responseData.OPTIONTEXT7 }}
                    </mat-checkbox>
                  </div>
                }
                @if (responseData.OPTIONTEXT8) {
                  <div fxFlex="50">
                    <mat-checkbox class="example-margin" formControlName="OPTIONTEXT8">
                      {{ responseData.OPTIONTEXT8 }}
                    </mat-checkbox>
                  </div>
                }
                @if (responseData.OPTIONTEXT9) {
                  <div>
                    <mat-checkbox class="example-margin" formControlName="OPTIONTEXT9">
                      {{ responseData.OPTIONTEXT9 }}
                    </mat-checkbox>
                  </div>
                }
                @if (responseData.OPTIONTEXT10) {
                  <div fxFlex="50">
                    <mat-checkbox class="example-margin" formControlName="OPTIONTEXT10">
                      {{ responseData.OPTIONTEXT10 }}
                    </mat-checkbox>
                  </div>
                }
              </div>
            </div>
          }
        </form>
      }
    </div>
  </div>
  <mat-dialog-actions class="popup_ftr justify-end!">
    @if (responseData && !isPDFGenerated && showwarningdiv == 'false') {
      <button
        matButton="filled"
        class="mat-accent"
        (click)="ReportSubmit()"
        [disabled]="
          (this.MatterFeildShow == 1 && mattername.length == 0) || ReportForm.hasError('dateRange')
        "
      >
        OK
      </button>
    }
    <!-- <button mat-raised-button color="accent" class="mat-accent" (click)="CompleteSubmit()"
      *ngIf="!reportSubmitted && isPDFGenerated">OK</button> -->
    @if (responseData && !isPDFGenerated && showwarningdiv == 'false') {
      <button
        matButton="tonal"
        [mat-dialog-close]="true"
        cdkFocusInitial
        (click)="ondialogcloseClick($event)"
      >
        Cancel
      </button>
    }
  </mat-dialog-actions>
</div>
